module.exports = __webpack_public_path__ + "static/media/device-charging.1f466afb.png";